<template>
  <table class="table groups" v-if="groups && groups.length > 0">
    <thead>
      <tr>
        <td>Type</td>
        <td>Aantal</td>
        <td>Prijs</td>
        <td>Commission</td>
        <td>Commission type</td>
        <td>Total</td>
      </tr>
    </thead>

    <tbody>
      <InvoiceGroup
        v-for="(group, index) in groups"
        :key="index"
        :group="group"
        @update:group="(value) => updateGroup(value, index)"
        @remove:group="removeGroup(index)"
        @add:group="addGroup(index)"
        :is-removable="groups.length > 1"
      />
    </tbody>
  </table>
</template>

<script setup>
import { defineProps } from "vue";
import InvoiceGroup from "./InvoiceGroup.vue";

const { groups } = defineProps({
  groups: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['add-group']);

const addGroup = (index) => {
    emit('add-group', index);
}

const updateGroup = (value, index) => {
    groups.splice(index, 1, { ...value });
}

const removeGroup = (index) => {
    groups.splice(index, 1);
}
</script>

<style scoped>
.groups {
  margin-bottom: 0;
}

.groups tr {
  background: transparent !important;
}
</style>
